import { ChallengeCriteriaType } from './ChallengeCriteria';

export const CHALLENGE_CRITERIAS: ChallengeCriteriaType[] = [
    { percent: 30, text: 'Оригинальность идеи проекта', icon: 'thinking' },
    { percent: 30, text: 'Визуальная составляющая', icon: 'picture' },
    { percent: 40, text: 'Мастерство использования нейросетей', icon: 'stars' },
];

export const getChallengeCriterias = (challengeTitle: string) => {
    if (challengeTitle === 'Пояснить за науку') {
        return [
            { percent: 30, text: 'Достоверность и раскрытие темы', icon: 'thinking' },
            ...CHALLENGE_CRITERIAS.slice(1),
        ];
    }

    return CHALLENGE_CRITERIAS;
};
